import React, { useEffect, useRef, useState } from 'react';

export function InfiniscrollContainer({
  children,
  onLoad,
  hasMore,
  variant,
}: React.PropsWithChildren<{ onLoad: () => Promise<void>; hasMore: boolean; variant: string }>) {
  const [loading, setLoading] = useState<boolean>(false);
  const scrollBoxRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const checkHeight = () => {
      const box = scrollBoxRef.current;
      if (box && hasMore && box.scrollHeight <= box.clientHeight) {
        onLoad();
      }
    };

    const timeout = setTimeout(checkHeight, 150);
    return () => clearTimeout(timeout);
  }, [hasMore, onLoad]);

  const loadIfNearBottom = async (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;
    const { scrollTop, scrollHeight, clientHeight } = target;
    const scrollPosition = scrollTop + clientHeight;

    if (scrollPosition === scrollHeight) target.scrollTo({ top: scrollTop - 110 });
    if (loading || !hasMore) return;

    if (scrollPosition >= scrollHeight - 100) {
      setLoading(true);
      await onLoad();
      setLoading(false);
    }
  };

  return (
    <div
      className={`h-100 overflow-auto ${variant === 'pipeline' ? 'container-element small' : variant === 'notifications' ? 'container-element' : ''}`}
      ref={scrollBoxRef}
      onScroll={loadIfNearBottom}
    >
      <div className={variant === 'pipeline' ? 'table-stop-growth' : ''}>{children}</div>
    </div>
  );
}
